<mat-sidenav-container [dir]="direction" class="sidenav-container">

  <mat-sidenav #drawer class="sidenav" fixedInViewport [attr.role]="(isHandset$ | async) ? 'dialog' : 'navigation'"
    [mode]="(isHandset$ | async) ? 'over' : 'side'" [opened]="(isHandset$ | async) === false">

    <div class="sidenav-brand">
      <div class="brand-logo"><mat-icon>credit_card</mat-icon></div>
      <div class="brand-text">
        <span class="brand-title">{{'cardsrecharged' | translate}}</span>
        <span class="brand-sub">{{'menu' | translate}}</span>
      </div>
    </div>

    @if (role != 'Admin') {
      <mat-nav-list class="main-nav">
        <!-- <a mat-list-item class="top-link" routerLink="./" routerLinkActive="active-link" [routerLinkActiveOptions]="{exact: true}"><mat-icon>dashboard</mat-icon>&nbsp; {{'dashboard' | translate}}</mat-list-item> -->
        @for (item of menuPerm; track item) {
          <mat-expansion-panel class="nav-group" [class.mat-elevation-z0]="true">
            <mat-expansion-panel-header>
            <mat-icon class="group-icon">folder</mat-icon>
            <span class="group-title">{{item.menuName | translate}}</span>
          </mat-expansion-panel-header>
            @for (menuitem of item.lstmenuItem; track menuitem) {
              <mat-nav-list class="sub-list">
                <a mat-list-item routerLinkActive="active-link" [routerLink]="'/master' + menuitem.link">
                  <mat-icon>{{menuitem.icon}}</mat-icon>{{menuitem.name | translate}}
                </a>
              </mat-nav-list>
            }
          </mat-expansion-panel>
        }
        <mat-list-item class="logout-item" (click)="logout()">
          <mat-icon>logout</mat-icon> {{'logout' | translate}}
        </mat-list-item>
      </mat-nav-list>
    }

    @if (role == 'Admin') {
      <mat-nav-list class="main-nav">
        <a mat-list-item class="top-link" routerLink="./" routerLinkActive="active-link" [routerLinkActiveOptions]="{exact: true}">
          <mat-icon>dashboard</mat-icon> {{'dashboard' | translate}}
        </a>
        <mat-expansion-panel class="nav-group" [class.mat-elevation-z0]="true">
          <mat-expansion-panel-header>
            <mat-icon class="group-icon">style</mat-icon>
            <span class="group-title">{{'cards' | translate}}</span>
          </mat-expansion-panel-header>
          <mat-nav-list class="sub-list">
            <a mat-list-item routerLinkActive="active-link" routerLink="./cards/categories">
              <mat-icon>category</mat-icon> {{'categories' | translate}}
            </a>
            <a mat-list-item routerLinkActive="active-link" routerLink="./cards/subcategory">
              <mat-icon>subdirectory_arrow_right</mat-icon>{{'subCategories' | translate}}
            </a>
            <a mat-list-item routerLinkActive="active-link" routerLink="./cards/products">
              <mat-icon>production_quantity_limits</mat-icon> {{'products' | translate}}
            </a>
            @if (role == 'Admin') {
              <a mat-list-item routerLinkActive="active-link" routerLink="./cards/advertize">
                <mat-icon>Announcement</mat-icon> {{'Advertize' | translate}}
              </a>
            }
            @if (role == 'Admin') {
              <a mat-list-item routerLinkActive="active-link" routerLink="./cards/productcards">
                <mat-icon>credit_card</mat-icon> {{'productCardsManagment' | translate}}
              </a>
            }
          </mat-nav-list>
        </mat-expansion-panel>
        @if (role == 'Admin') {
          <mat-expansion-panel class="nav-group" [class.mat-elevation-z0]="true">
            <mat-expansion-panel-header>
            <mat-icon class="group-icon">receipt</mat-icon>
            <span class="group-title">{{'EFawateercome' | translate}}</span>
          </mat-expansion-panel-header>
            <mat-nav-list class="sub-list">
              <a mat-list-item routerLinkActive="active-link" routerLink="./efawateercome/efcategoriesList">
                <mat-icon>category</mat-icon> {{ 'categories' | translate}}
              </a>
              <a mat-list-item routerLinkActive="active-link" routerLink="./efawateercome/efbillerslist">
                <mat-icon>business</mat-icon> {{ 'billers' | translate}}
              </a>
              <a mat-list-item routerLinkActive="active-link" routerLink="./efawateercome/efbillersservicetypelist">
                <mat-icon>miscellaneous_services</mat-icon> {{ 'services' | translate}}
              </a>
              <a mat-list-item routerLinkActive="active-link" routerLink="./efawateercome/effeescategory">
                <mat-icon>percent</mat-icon> {{ 'efCategoryFees' | translate}}
              </a>
            </mat-nav-list>
          </mat-expansion-panel>
        }
        @if (role == 'Admin') {
          <mat-expansion-panel class="nav-group" [class.mat-elevation-z0]="true">
            <mat-expansion-panel-header>
            <mat-icon class="group-icon">analytics</mat-icon>
            <span class="group-title">{{'efReports' | translate}}</span>
          </mat-expansion-panel-header>
            <mat-nav-list class="sub-list">
              <a mat-list-item routerLinkActive="active-link" routerLink="./efawateercomereports/efordersbyid">
                <mat-icon>tag</mat-icon> {{ 'efOrderById' | translate}}
              </a>
              <a mat-list-item routerLinkActive="active-link" routerLink="./efawateercomereports/efordersbyuser">
                <mat-icon>person_search</mat-icon> {{ 'efOrderByUser' | translate}}
              </a>
              <a mat-list-item routerLinkActive="active-link" routerLink="./efawateercomereports/efordersbycategory">
                <mat-icon>category</mat-icon> {{ 'efOrderBycategory' | translate}}
              </a>
              <a mat-list-item routerLinkActive="active-link" routerLink="./efawateercomereports/efordersbybiller">
                <mat-icon>business</mat-icon> {{ 'efOrderBybiller' | translate}}
              </a>
              <a mat-list-item routerLinkActive="active-link" routerLink="./efawateercomereports/efordersbyservicetype">
                <mat-icon>miscellaneous_services</mat-icon> {{ 'efOrderByService' | translate}}
              </a>
              <a mat-list-item routerLinkActive="active-link" routerLink="./efawateercomereports/efpostpaidorders">
                <mat-icon>event_repeat</mat-icon> {{ 'efPostpaidOrder' | translate}}
              </a>
              <a mat-list-item routerLinkActive="active-link" routerLink="./efawateercomereports/efprepaidorders">
                <mat-icon>payments</mat-icon> {{ 'efPrepaidOrder' | translate}}
              </a>
            </mat-nav-list>
          </mat-expansion-panel>
        }
        <mat-expansion-panel class="nav-group" [class.mat-elevation-z0]="true">
          <mat-expansion-panel-header>
            <mat-icon class="group-icon">tune</mat-icon>
            <span class="group-title">{{'options' | translate}}</span>
          </mat-expansion-panel-header>
          <mat-nav-list class="sub-list">
            <a mat-list-item routerLinkActive="active-link" routerLink="./options/customers">
              <mat-icon>groups</mat-icon> {{ 'customers' | translate}}
            </a>
            @if (role == 'Admin') {
              <a mat-list-item routerLinkActive="active-link" routerLink="./options/adduser">
                <mat-icon>person_add</mat-icon>{{'addUser' | translate}}
              </a>
            }
            @if (role == 'Admin') {
              <a mat-list-item routerLinkActive="active-link" routerLink="./options/addcustomer">
                <mat-icon>smartphone</mat-icon>{{'addUserMobile' | translate}}
              </a>
            }
            @if (role == 'Admin') {
              <a mat-list-item routerLinkActive="active-link" routerLink="./options/mandoobsList">
                <mat-icon>badge</mat-icon>{{'MandoobsMenu' | translate}}
              </a>
            }
            @if (role == 'Admin') {
              <a mat-list-item routerLinkActive="active-link" routerLink="./options/salePoints">
                <mat-icon>storefront</mat-icon>{{'salePoints' | translate}}
              </a>
            }
            @if (role == 'Admin') {
              <a mat-list-item routerLinkActive="active-link" routerLink="./options/regions">
                <mat-icon>map</mat-icon>{{'regions' | translate}}
              </a>
            }
            @if (role == 'Admin') {
              <a mat-list-item routerLinkActive="active-link" routerLink="./options/updateuserbalance">
                <mat-icon>attach_money</mat-icon>{{'usersBalance' | translate}}
              </a>
            }
            @if (role == 'Admin') {
              <a mat-list-item routerLinkActive="active-link" routerLink="./options/updatemandoobbalance">
                <mat-icon>attach_money</mat-icon>{{'mandoobsBalance' | translate}}
              </a>
            }
            @if (role == 'Admin') {
              <a mat-list-item routerLinkActive="active-link" (click)="onClickMessages()" routerLink="./options/messages">
                <mat-icon>message</mat-icon> <span [matBadge]="notSeenMessageCount" [matBadgeHidden]="notSeenMessageCount == 0" matBadgeColor="warn"
                  matBadgeOverlap="false">{{'messages' | translate}}</span>
              </a>
            }
            @if (role == 'Admin') {
              <a mat-list-item routerLinkActive="active-link" (click)="onClickDirectCharge()" routerLink="./options/directcharge">
                <mat-icon>bolt</mat-icon> <span [matBadge]="notSeenDirectChargeCount" [matBadgeHidden]="notSeenDirectChargeCount == 0"
                  matBadgeColor="warn" matBadgeOverlap="false">{{'directChargeOrders' | translate}}</span>
              </a>
            }
            @if (role == 'Admin') {
              <a mat-list-item routerLinkActive="active-link" routerLink="./options/walletrequests">
                <mat-icon>account_balance_wallet</mat-icon>{{'walletRequests' | translate}}
              </a>
            }
            @if (role == 'Admin') {
              <a mat-list-item routerLinkActive="active-link" routerLink="./options/deviceapprovals">
                <mat-icon>phonelink_lock</mat-icon> <span [matBadge]="pendingDevicesCount" [matBadgeHidden]="pendingDevicesCount == 0"
                  matBadgeColor="warn" matBadgeOverlap="false">{{'deviceApprovals' | translate}}</span>
              </a>
            }
            @if (role == 'Admin') {
              <a mat-list-item routerLinkActive="active-link" routerLink="./options/systemdata">
                <mat-icon>dns</mat-icon>{{'systemData' | translate}}
              </a>
            }
            @if (role == 'Admin') {
              <a mat-list-item routerLinkActive="active-link" routerLink="./options/auditlog">
                <mat-icon>history</mat-icon>{{'auditLog' | translate}}
              </a>
            }
            @if (role == 'Admin') {
              <a mat-list-item routerLinkActive="active-link" routerLink="./options/usercategorylimits">
                <mat-icon>rule</mat-icon>{{'userCategoryLimits' | translate}}
              </a>
            }
            @if (role == 'Admin') {
              <a mat-list-item routerLinkActive="active-link" routerLink="./options/notification">
                <mat-icon>notifications</mat-icon>{{'notifications' | translate}}
              </a>
            }
            @if (role == 'Admin') {
              <a mat-list-item routerLinkActive="active-link" routerLink="./options/alert">
                <mat-icon>campaign</mat-icon>{{'alert' | translate}}
              </a>
            }
            <!-- <a *ngIf="role == 'Admin'" mat-list-item routerLink="./options/sendSMS">
            <mat-icon>textsms</mat-icon>{{'sendSMS' | translate}}
          </a> -->
          @if (role == 'Admin') {
            <a mat-list-item routerLinkActive="active-link" routerLink="./cards/paymentproviders">
              <mat-icon>attach_money</mat-icon>{{'paymentProviders' | translate}}
            </a>
          }
          @if (role == 'Admin') {
            <a mat-list-item routerLinkActive="active-link" routerLink="./cards/customservices">
              <mat-icon>miscellaneous_services</mat-icon>{{'customServices' | translate}}
            </a>
          }
          @if (role == 'Admin') {
            <a mat-list-item routerLinkActive="active-link" routerLink="./cards/paymentrequests">
              <mat-icon>receipt_long</mat-icon>{{'ordersPay' | translate}}
            </a>
          }
          @if (role == 'Admin') {
            <a mat-list-item routerLinkActive="active-link" routerLink="./options/otherInfoList">
              <mat-icon>info</mat-icon>{{'otherInfo' | translate}}
            </a>
          }
        </mat-nav-list>
      </mat-expansion-panel>
      <mat-expansion-panel class="nav-group" [class.mat-elevation-z0]="true">
        <mat-expansion-panel-header>
            <mat-icon class="group-icon">assessment</mat-icon>
            <span class="group-title">{{'reports' | translate}}</span>
          </mat-expansion-panel-header>
        <mat-nav-list class="sub-list">
          <a mat-list-item routerLinkActive="active-link" routerLink="./reports/orderbyid">
            <mat-icon>tag</mat-icon>{{'orderById' | translate}}
          </a>
          <a mat-list-item routerLinkActive="active-link" routerLink="./reports/allByDate">
            <mat-icon>date_range</mat-icon>{{'cardsOrders' | translate}}
          </a>
          <a mat-list-item routerLinkActive="active-link" routerLink="./reports/mandoobStatment">
            <mat-icon>badge</mat-icon>{{'mandoobStatment' | translate}}
          </a>
          <a mat-list-item routerLinkActive="active-link" routerLink="./reports/ordersbycategorystatment">
            <mat-icon>category</mat-icon>{{'orderByCategoryStatment' | translate}}
          </a>
          <a mat-list-item routerLinkActive="active-link" routerLink="./reports/ordersbysubcategorystatment">
            <mat-icon>subdirectory_arrow_right</mat-icon>{{'orderBySubCategoryStatment' | translate}}
          </a>
          <a mat-list-item routerLinkActive="active-link" routerLink="./reports/ordersbyproductstatment">
            <mat-icon>inventory_2</mat-icon>{{'orderByProductStatment' | translate}}
          </a>
          <a mat-list-item routerLinkActive="active-link" routerLink="./reports/ordersbydirectcharged">
            <mat-icon>bolt</mat-icon>{{'directChargedStatment' | translate}}
          </a>
          <a mat-list-item routerLinkActive="active-link" routerLink="./reports/ordersbyuser">
            <mat-icon>person_search</mat-icon>{{'statmentByUser' | translate}}
          </a>
          <a mat-list-item routerLinkActive="active-link" routerLink="./reports/usertrans">
            <mat-icon>swap_horiz</mat-icon>{{'userTrans' | translate}}
          </a>
          <a mat-list-item routerLinkActive="active-link" routerLink="./reports/usertransdeposits">
            <mat-icon>savings</mat-icon>{{'userTransdeposit' | translate}}
          </a>
          <a mat-list-item routerLinkActive="active-link" routerLink="./reports/usertranstransfers">
            <mat-icon>sync_alt</mat-icon>{{'userTransTransfer' | translate}}
          </a>
          @if (role == 'Admin') {
            <a mat-list-item routerLinkActive="active-link" routerLink="./reports/statistics">
              <mat-icon>insights</mat-icon>{{'statisticsReports' | translate}}
            </a>
          }
          <a mat-list-item routerLinkActive="active-link" routerLink="./reports/unifiedoperations">
            <mat-icon>list_alt</mat-icon>{{'unifiedOperations' | translate}}
          </a>
          <a mat-list-item routerLinkActive="active-link" routerLink="./reports/usertransall">
            <mat-icon>receipt_long</mat-icon>{{'userOrdersReport' | translate}}
          </a>
          <a mat-list-item routerLinkActive="active-link" routerLink="./reports/profits">
            <mat-icon>trending_up</mat-icon>{{'calculateProfits' | translate}}
          </a>
          <a mat-list-item routerLinkActive="active-link" routerLink="./reports/productcardsreport">
            <mat-icon>credit_card</mat-icon>{{'productCardsReport' | translate}}
          </a>
          <a mat-list-item routerLinkActive="active-link" routerLink="./reports/pyticorderscard">
            <mat-icon>sports_esports</mat-icon>{{'pyticOrderCards' | translate}}
          </a>
          <a mat-list-item routerLinkActive="active-link" routerLink="./reports/mandoobtrans">
            <mat-icon>swap_horiz</mat-icon>{{'mandoobTrans' | translate}}
          </a>
          <a mat-list-item routerLinkActive="active-link" routerLink="./reports/userbymandoobtrans">
            <mat-icon>people</mat-icon>{{'userBymandoobTrans' | translate}}
          </a>
        </mat-nav-list>
      </mat-expansion-panel>
      <mat-expansion-panel class="nav-group" [class.mat-elevation-z0]="true">
        <mat-expansion-panel-header>
            <mat-icon class="group-icon">settings</mat-icon>
            <span class="group-title">{{'systemSettings' | translate}}</span>
          </mat-expansion-panel-header>
        <mat-nav-list class="sub-list">
          <!-- <a mat-list-item routerLinkActive="active-link" routerLink="./systemsettings/menus">
          <mat-icon>article</mat-icon>Menu
        </a>
        <a mat-list-item routerLinkActive="active-link" routerLink="./systemsettings/menuitems">
          <mat-icon>article</mat-icon>Menu items
        </a> -->
        <a mat-list-item routerLinkActive="active-link" routerLink="./systemsettings/permissions">
          <mat-icon>admin_panel_settings</mat-icon>{{'permissions' | translate}}
        </a>
        <a mat-list-item routerLinkActive="active-link" routerLink="./systemsettings/appColor">
          <mat-icon>palette</mat-icon>{{'settings' | translate}}
        </a>
        <a mat-list-item routerLinkActive="active-link" routerLink="./systemsettings/qrcategory">
          <mat-icon>qr_code_2</mat-icon>{{'qrCategories' | translate}}
        </a>
        <a mat-list-item routerLinkActive="active-link" routerLink="./systemsettings/commissions">
          <mat-icon>attach_money</mat-icon>{{'commissionRules' | translate}}
        </a>
        <a mat-list-item routerLinkActive="active-link" routerLink="./systemsettings/categorypermission">
          <mat-icon>lock_person</mat-icon>{{'categoryPermission' | translate}}
        </a>
        <a mat-list-item routerLinkActive="active-link" routerLink="./systemsettings/assistancedirectchargepermission">
          <mat-icon>support_agent</mat-icon>{{'assistanceDirectCharge' | translate}}
        </a>
      </mat-nav-list>
    </mat-expansion-panel>
    <mat-list-item class="logout-item" (click)="logout()">
      <mat-icon>logout</mat-icon> {{'logout' | translate}}
    </mat-list-item>
  </mat-nav-list>
}

</mat-sidenav>
<mat-sidenav-content>
  <mat-toolbar class="topbar">
    <button type="button" class="topbar-toggle" aria-label="Toggle sidenav" mat-icon-button (click)="drawer.toggle()">
      <mat-icon>menu</mat-icon>
    </button>
    <span class="topbar-title">{{'cardsrecharged' | translate}}</span>
    <span class="spacer"></span>

    <button mat-button class="user-chip" [matMenuTriggerFor]="menu">
      <span class="user-avatar">{{ (userFullName || '?').charAt(0) }}</span>
      <span class="user-name">{{userFullName}}</span>
      <mat-icon class="user-caret">expand_more</mat-icon>
    </button>
    <mat-menu #menu="matMenu" xPosition="before" class="user-menu">
      <button mat-menu-item routerLink="./options/changePassword">
        <mat-icon>lock_reset</mat-icon>{{'changePassword' | translate}}
      </button>
      <button mat-menu-item (click)="logout()">
        <mat-icon>logout</mat-icon>{{'logout' | translate}}
      </button>
    </mat-menu>
  </mat-toolbar>
  <!-- Add Content Here -->
  <div class="page-content">
    <router-outlet></router-outlet>
  </div>
</mat-sidenav-content>
</mat-sidenav-container>